import { userProgramOrderSaga } from './userProgramOrder'

export default function* orderSaga() {
  yield userProgramOrderSaga()
}
